<template>
  <div class="image-options-setting-dialog">
    <div v-show="activeType == 1" class="content-group-default">
      <el-collapse v-model="activeNames">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="页码按钮"
          name="2"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <text-setting-complex-update
              class="mb16"
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :letterSpacing.sync="letterSpacing"
              :showTextAlignSetting="false"
              :lineHeightType.sync="lineHeightType"
              :letterSpacingType.sync="letterSpacingType"
              :showColorSet="false"
              :hideHighLevelSetting="true"
              :options="options"
            />
            <div class="verticallyCenter mb16">
              <span class="fs14 mr16">颜色</span>
              <color-picker-theme-color class="flex1" :isThemeColor.sync="textIsThemeColor" :color.sync="color" />
            </div>
            <slider-and-input class="mb16" :value.sync="itemMargin" title="页码间距" :sliderMax="40" suffix="px" />
            <slider-and-input class="mb16" :value.sync="minWidth" title="最小宽度" :sliderMax="100" suffix="px" />
            <div class="content">
              <div class="content-item clearFloat mb24">
                <div class="title14_20 mb16">背景</div>
                <color-picker-theme-color
                  :isThemeColor.sync="bgColorIsThemeColor"
                  :color.sync="bgColor"
                  class="custom-text-bg mt16"
                />
              </div>
              <div class="content-item clearFloat mb24">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb24">
                <cx-padding
                  :paddingTypeFlag.sync="paddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
              <div class="content-item clearFloat">
                <div class="title14_20 mb16">边框</div>
                <div class="content">
                  <div class="select-input-container verticallyTop">
                    <cx-border
                      :borderWidth.sync="borderWidth"
                      :borderStyle.sync="borderStyle"
                      :borderColor.sync="borderColor"
                      :borderIsThemeColor.sync="borderIsThemeColor"
                    />
                  </div>
                </div>
              </div>
              <div class="content-item mt16">
                <div class="checkbox_colorPicker_container">
                  <span>阴影</span>
                  <span class="icon-portal-plus theme-color right-icon"></span>
                </div>
                <box-shadow
                  :boxShadowH.sync="boxShadowH"
                  :boxShadowV.sync="boxShadowV"
                  :boxShadowBlur.sync="boxShadowBlur"
                  :boxShadowSpread.sync="boxShadowSpread"
                  :boxShadowColor.sync="boxShadowColor"
                ></box-shadow>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
          title="翻页按钮"
          name="3"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
          >
            <div class="content-item mb16 verticallyCenter">
              <span class="mr16 fs14">按钮样式</span>
              <el-radio-group v-model="pageTurnType">
                <el-radio label="icon">图标</el-radio>
                <el-radio label="font">文字</el-radio>
              </el-radio-group>
            </div>
            <template v-if="pageTurnType === 'icon'">
              <icon-select class="mb16" :selectedIcon.sync="pageTurnIcon"></icon-select>
              <div class="verticallyCenter mb24">
                <span class="fs14 mr16">颜色</span>
                <color-picker-theme-color
                  class="flex1"
                  :isThemeColor.sync="pageTurnIconIsThemeColor"
                  :color.sync="pageTurnIconColor"
                />
              </div>
              <div class="mb24">
                <slider-and-input
                  :value.sync="pageTurnFontSize"
                  title="图标大小"
                  :sliderMax="100"
                  :sliderMin="12"
                  suffix="px"
                />
              </div>
            </template>
            <template v-else-if="pageTurnType === 'font'">
              <text-setting-update
                class="mb24"
                :fontColor.sync="pageTurnFontColor"
                :fontFamily.sync="pageTurnFontFamily"
                :fontSize.sync="pageTurnFontSize"
                :fontWeight.sync="pageTurnFontWeight"
              />
            </template>
            <div class="content-item mb24">
              <slider-and-input :value.sync="pageTurnHeight" title="高度" :sliderMax="100" suffix="px" />
            </div>
            <div class="content">
              <div class="content-item clearFloat mb24">
                <border-radius
                  :borderTypeFlag.sync="pageTurnBorderTypeFlag"
                  :borderRadius.sync="pageTurnBorderRadius"
                  :borderTopLeftRadius.sync="pageTurnBorderTopLeftRadius"
                  :borderTopRightRadius.sync="pageTurnBorderTopRightRadius"
                  :borderBottomRightRadius.sync="pageTurnBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="pageTurnBorderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb24">
                <cx-padding
                  :paddingTypeFlag.sync="pageTurnPaddingTypeFlag"
                  :padding.sync="pageTurnPadding"
                  :paddingTop.sync="pageTurnPaddingTop"
                  :paddingRight.sync="pageTurnPaddingRight"
                  :paddingBottom.sync="pageTurnPaddingBottom"
                  :paddingLeft.sync="pageTurnPaddingLeft"
                />
              </div>
              <div class="content-item clearFloat">
                <div class="title14_20 mb16">边框</div>
                <div class="content">
                  <div class="select-input-container verticallyTop">
                    <cx-border
                      :borderWidth.sync="pageTurnBorderWidth"
                      :borderStyle.sync="pageTurnBorderStyle"
                      :borderColor.sync="pageTurnBorderColor"
                      :borderIsThemeColor.sync="pageTurnBorderIsThemeColor"
                    />
                  </div>
                </div>
              </div>
              <div class="content-item clearFloat mb24">
                <div class="title14_20 mb16">背景</div>
                <color-picker-theme-color
                  :isThemeColor.sync="pageTurnBgIsThemeColor"
                  :color.sync="pageTurnBgColor"
                  class="custom-text-bg mt16"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="页码功能"
          name="4"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="verticallyCenter">
              <cx-select :value.sync="maxPageBtnNum" :selectOptions="btnNumSelectOptions" title="最大页码按钮数量" />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
          title="拓展显示"
          name="5"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
          >
            <cx-check-box :value.sync="hideOnSinglePage">只有一页时隐藏分页</cx-check-box>
            <cx-check-box class="mt16" :value.sync="showJumper">显示“快速跳转至某页”</cx-check-box>
            <cx-check-box class="mt16" :value.sync="showTotal">显示“总条数”</cx-check-box>
            <div class="mt16">
              <span>文字样式</span>
              <text-setting-update
                class="mt8"
                :fontColor.sync="otherFontColor"
                :fontFamily.sync="otherFontFamily"
                :fontSize.sync="otherFontSize"
                :fontWeight.sync="otherFontWeight"
              />
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')" title="外观" name="6">
          <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')">
            <div class="content-item">
              <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
            </div>
            <cx-background :background.sync="background" imgType="10" class="mt16" />
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="allBoxShadowH"
                :boxShadowV.sync="allBoxShadowV"
                :boxShadowBlur.sync="allBoxShadowBlur"
                :boxShadowSpread.sync="allBoxShadowSpread"
                :boxShadowColor.sync="allBoxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')" title="边框" name="7">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
          >
            <div class="content">
              <div class="content-item mb16">
                <border-radius
                  :borderTypeFlag.sync="allBorderTypeFlag"
                  :borderRadius.sync="allBorderRadius"
                  :borderTopLeftRadius.sync="allBorderTopLeftRadius"
                  :borderTopRightRadius.sync="allBorderTopRightRadius"
                  :borderBottomRightRadius.sync="allBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="allBorderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb24 clearFloat">
                <div class="checkbox_colorPicker_container mb16">
                  <span class="fs14">边框</span>
                </div>
                <div v-show="borderChecked" class="select-input-container verticallyTop">
                  <cx-border
                    :borderWidth.sync="allBorderWidth"
                    :borderStyle.sync="allBorderStyle"
                    :borderColor.sync="allBorderColor"
                    :borderIsThemeColor.sync="allBorderIsThemeColor"
                  />
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')" title="边距" name="8">
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')"
          >
            <div class="content">
              <div class="content-item">
                <cx-padding
                  :paddingTypeFlag.sync="allPaddingTypeFlag"
                  :padding.sync="allPadding"
                  :paddingTop.sync="allPaddingTop"
                  :paddingRight.sync="allPaddingRight"
                  :paddingBottom.sync="allPaddingBottom"
                  :paddingLeft.sync="allPaddingLeft"
                  :sliderMax="40"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-show="activeType == 2" class="content-group-active">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="页码按钮"
          name="2"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <text-setting-update
              class="mb24"
              :fontColor.sync="activeColor"
              :fontFamily.sync="activeFontFamily"
              :fontSize.sync="activeFontSize"
              :fontWeight.sync="activeFontWeight"
            />
            <div class="content-item clearFloat mb24">
              <div class="title14_20 mb16">背景</div>
              <color-picker-theme-color
                :isThemeColor.sync="activeBgColorIsThemeColor"
                :color.sync="activeBgColor"
                class="custom-text-bg mt16"
              />
            </div>
            <div class="content-item clearFloat mb24">
              <border-radius
                :borderTypeFlag.sync="activeBorderTypeFlag"
                :borderRadius.sync="activeBorderRadius"
                :borderTopLeftRadius.sync="activeBorderTopLeftRadius"
                :borderTopRightRadius.sync="activeBorderTopRightRadius"
                :borderBottomRightRadius.sync="activeBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="activeBorderBottomLeftRadius"
              />
            </div>
            <div class="content-item mb24">
              <cx-padding
                :paddingTypeFlag.sync="activePaddingTypeFlag"
                :padding.sync="activePadding"
                :paddingTop.sync="activePaddingTop"
                :paddingRight.sync="activePaddingRight"
                :paddingBottom.sync="activePaddingBottom"
                :paddingLeft.sync="activePaddingLeft"
              />
            </div>
            <div class="content-item clearFloat">
              <div class="title14_20 mb16">边框</div>
              <div class="content">
                <div class="select-input-container verticallyTop">
                  <cx-border
                    :borderWidth.sync="activeBorderWidth"
                    :borderStyle.sync="activeBorderStyle"
                    :borderColor.sync="activeBorderColor"
                    :borderIsThemeColor.sync="activeBorderIsThemeColor"
                  />
                </div>
              </div>
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="activeBoxShadowH"
                :boxShadowV.sync="activeBoxShadowV"
                :boxShadowBlur.sync="activeBoxShadowBlur"
                :boxShadowSpread.sync="activeBoxShadowSpread"
                :boxShadowColor.sync="activeBoxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div v-show="activeType == 3" class="content-group-hover">
      <el-collapse v-model="activeNames">
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
          title="页码按钮"
          name="2"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
          >
            <text-setting-update
              class="mb24"
              :fontColor.sync="hoverColor"
              :fontFamily.sync="hoverFontFamily"
              :fontSize.sync="hoverFontSize"
              :fontWeight.sync="hoverFontWeight"
            />
            <div class="content-item clearFloat mb24">
              <div class="title14_20 mb16">背景</div>
              <color-picker-theme-color
                :isThemeColor.sync="hoverBgColorIsThemeColor"
                :color.sync="hoverBgColor"
                class="custom-text-bg mt16"
              />
            </div>
            <div class="content-item clearFloat mb24">
              <border-radius
                :borderTypeFlag.sync="hoverBorderTypeFlag"
                :borderRadius.sync="hoverBorderRadius"
                :borderTopLeftRadius.sync="hoverBorderTopLeftRadius"
                :borderTopRightRadius.sync="hoverBorderTopRightRadius"
                :borderBottomRightRadius.sync="hoverBorderBottomRightRadius"
                :borderBottomLeftRadius.sync="hoverBorderBottomLeftRadius"
              />
            </div>
            <div class="content-item mb24">
              <cx-padding
                :paddingTypeFlag.sync="hoverPaddingTypeFlag"
                :padding.sync="hoverPadding"
                :paddingTop.sync="hoverPaddingTop"
                :paddingRight.sync="hoverPaddingRight"
                :paddingBottom.sync="hoverPaddingBottom"
                :paddingLeft.sync="hoverPaddingLeft"
              />
            </div>
            <div class="content-item clearFloat">
              <div class="title14_20 mb16">边框</div>
              <div class="content">
                <div class="select-input-container verticallyTop">
                  <cx-border
                    :borderWidth.sync="hoverBorderWidth"
                    :borderStyle.sync="hoverBorderStyle"
                    :borderColor.sync="hoverBorderColor"
                    :borderIsThemeColor.sync="hoverBorderIsThemeColor"
                  />
                </div>
              </div>
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="hoverBoxShadowH"
                :boxShadowV.sync="hoverBoxShadowV"
                :boxShadowBlur.sync="hoverBoxShadowBlur"
                :boxShadowSpread.sync="hoverBoxShadowSpread"
                :boxShadowColor.sync="hoverBoxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
          title="翻页按钮"
          name="4"
        >
          <div
            class="setting-item"
            v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
          >
            <div class="verticallyCenter mb24">
              <span class="fs14 mr16">颜色</span>
              <color-picker-theme-color
                v-if="pageTurnType === 'icon'"
                class="flex1"
                :isThemeColor.sync="hoverPageTurnBgIsThemeColor"
                :color.sync="hoverPageTurnIconColor"
              />
              <color-picker class="flex1" v-else :color.sync="hoverPageTurnFontColor" />
            </div>

            <div class="content">
              <div class="content-item clearFloat mb24">
                <border-radius
                  :borderTypeFlag.sync="hoverPageTurnBorderTypeFlag"
                  :borderRadius.sync="hoverPageTurnBorderRadius"
                  :borderTopLeftRadius.sync="hoverPageTurnBorderTopLeftRadius"
                  :borderTopRightRadius.sync="hoverPageTurnBorderTopRightRadius"
                  :borderBottomRightRadius.sync="hoverPageTurnBorderBottomRightRadius"
                  :borderBottomLeftRadius.sync="hoverPageTurnBorderBottomLeftRadius"
                />
              </div>
              <div class="content-item mb24">
                <cx-padding
                  :paddingTypeFlag.sync="hoverPageTurnPaddingTypeFlag"
                  :padding.sync="hoverPageTurnPadding"
                  :paddingTop.sync="hoverPageTurnPaddingTop"
                  :paddingRight.sync="hoverPageTurnPaddingRight"
                  :paddingBottom.sync="hoverPageTurnPaddingBottom"
                  :paddingLeft.sync="hoverPageTurnPaddingLeft"
                />
              </div>
              <div class="content-item clearFloat">
                <div class="title14_20 mb16">边框</div>
                <div class="content">
                  <div class="select-input-container verticallyTop">
                    <cx-border
                      :borderWidth.sync="hoverPageTurnBorderWidth"
                      :borderStyle.sync="hoverPageTurnBorderStyle"
                      :borderColor.sync="hoverPageTurnBorderColor"
                      :borderIsThemeColor.sync="hoverPageTurnBorderIsThemeColor"
                    />
                  </div>
                </div>
              </div>
              <div class="content-item clearFloat mb24">
                <div class="title14_20 mb16">背景</div>
                <color-picker-theme-color
                  :isThemeColor.sync="hoverPageTurnBgIsThemeColor"
                  :color.sync="hoverPageTurnBgColor"
                  class="custom-text-bg mt16"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import iconSelect from "materials/swiper/toolbars/settings/icon-select.vue"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import { CATEGORY_MODE } from "@/consts"
export default {
  name: "image-options-data",
  components: { controlWidthAndSizeAndZindex, iconSelect },
  props: { options: Object, activeType: String },
  data() {
    return {
      this1: this,
      collapseActiveNames: ["1", "2", "9"],
      activeNames: ["1", "2", "9"],
      allCollapseNames: ["3", "4", "5", "6", "7", "8"],
      iconLocations: [
        {
          value: "left",
          title: "文字居左"
        },
        {
          value: "right",
          title: "文字居右"
        }
      ],
      sliderMin: 1,
      sliderMax: 5,
      isShowBackgroundList: [
        {
          label: 0,
          title: "无背景"
        },
        {
          label: 1,
          title: "有背景"
        }
      ],
      borderChecked: true,
      allTabs: [],
      getAllTabsIsCheckedAll: false,
      allTabsIsCheckedAll: false,
      btnNumSelectOptions: [
        {
          value: 5,
          label: 5
        },
        {
          value: 7,
          label: 7
        },
        {
          value: 9,
          label: 9
        },
        {
          value: 11,
          label: 11
        },
        {
          value: 13,
          label: 13
        },
        {
          value: 15,
          label: 15
        },
        {
          value: 17,
          label: 17
        }
      ]
    }
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    isShowSyncSet() {
      return this.options.isNoSyncData ? false : true
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    hoverActiveArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.hoverWritingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "hoverWritingMode", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    hoverActiveArrangement() {
      return this.options.hoverTextAlign
    },
    width: {
      get() {
        return this.options.width
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "width", false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "height", false)
      }
    },
    itemMargin: {
      get() {
        return this.options.itemMargin
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "itemMargin", false)
      }
    },
    minWidth: {
      get() {
        return this.options.minWidth
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "minWidth", false)
      }
    },
    iconHeight: {
      get() {
        return this.options.iconHeight || 16
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "iconHeight", false)
      }
    },
    showIconChecked: {
      get() {
        return this.options.showIconChecked
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showIconChecked", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "left", false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "top", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontWeight", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },

    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    hoverTextDecoration: {
      get() {
        return this.options.hoverTextDecoration || this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverTextDecoration", false)
      }
    },
    textIndent: {
      get() {
        return this.options.textIndent
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIndent", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColor", false)
      }
    },
    marginRight: {
      get() {
        return this.options.marginRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginRight", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return this.options.borderTopLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return this.options.borderTopRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return this.options.borderBottomRightRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return this.options.borderBottomLeftRadius
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        // return this.checkAndSetPrimaryVal(this.options, "borderTypeFlag", "borderTypeFlag", defaultType)
        // 上面方法貌似是执行需要一定的时间，造成最开始还未写入值，进行点击 会出现问题
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "borderWidth", "borderWidth", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    isShowBackgroundModel: {
      get() {
        return this.options.isShowBackgroundModel || "无背景"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isShowBackgroundModel", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("bgColorIsThemeColor") ? this.options.bgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    opacity: {
      get() {
        return this.options.hasOwnProperty("opacity") ? this.options.opacity : 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = []
        if (this.bgType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgType === "纯色" ? this.allBgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    bgType: {
      get() {
        return this.options.bgType || "纯色"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgType", false)
      }
    },
    allBgColor: {
      get() {
        return this.options.allBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBgColor", false)
      }
    },
    bgStartColor: {
      get() {
        return this.options.bgStartColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgStartColor", false)
      }
    },
    bgEndColor: {
      get() {
        return this.options.bgEndColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgEndColor", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.hasOwnProperty("boxShadowColor") ? this.options.boxShadowColor : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.hasOwnProperty("boxShadowH") ? this.options.boxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.hasOwnProperty("boxShadowV") ? this.options.boxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("boxShadowBlur") ? this.options.boxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("boxShadowSpread") ? this.options.boxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    pageTurnType: {
      get() {
        return this.options.pageTurnType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnType", false)
      }
    },
    pageTurnIcon: {
      get() {
        return this.options.pageTurnIcon
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnIcon", false)
      }
    },
    pageTurnIconWidth: {
      get() {
        return this.options.pageTurnIconWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnIconWidth", false)
      }
    },
    pageTurnColor: {
      get() {
        return this.options.pageTurnColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnColor", false)
      }
    },
    pageTurnBgColor: {
      get() {
        return this.options.pageTurnBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBgColor", false)
      }
    },
    pageTurnBgIsThemeColor: {
      get() {
        return this.options.pageTurnBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBgIsThemeColor", false)
      }
    },
    pageTurnFontSize: {
      get() {
        return this.options.pageTurnFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnFontSize", false)
      }
    },
    pageTurnFontFamily: {
      get() {
        return this.options.pageTurnFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnFontFamily", false)
      }
    },
    pageTurnFontWeight: {
      get() {
        return this.options.pageTurnFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnFontWeight", false)
      }
    },
    pageTurnFontColor: {
      get() {
        return this.options.pageTurnFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnFontColor", false)
      }
    },
    pageTurnHeight: {
      get() {
        return this.options.pageTurnHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnHeight", false)
      }
    },
    pageTurnIconColor: {
      get() {
        return this.options.pageTurnIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnIconColor", false)
      }
    },
    pageTurnIconIsThemeColor: {
      get() {
        return this.options.pageTurnIconIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnIconIsThemeColor", false)
      }
    },

    pageTurnPadding: {
      get() {
        return this.options.pageTurnPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnPadding", false)
      }
    },
    pageTurnPaddingTop: {
      get() {
        return this.options.pageTurnPaddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnPaddingTop", false)
      }
    },
    pageTurnPaddingRight: {
      get() {
        return this.options.pageTurnPaddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnPaddingRight", false)
      }
    },
    pageTurnPaddingLeft: {
      get() {
        return this.options.pageTurnPaddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnPaddingLeft", false)
      }
    },
    pageTurnPaddingBottom: {
      get() {
        return this.options.pageTurnPaddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnPaddingBottom", false)
      }
    },
    pageTurnPaddingTypeFlag: {
      get() {
        return this.options.pageTurnPaddingTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnPaddingTypeFlag", false)
      }
    },

    pageTurnBorderTypeFlag: {
      get() {
        return this.options.allBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTypeFlag", false)
      }
    },
    pageTurnBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "pageTurnBorderRadius",
          "pageTurnBorderRadius",
          this.pageTurnBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.pageTurnBorderTypeFlag === 2) {
          this.pageTurnBorderTopLeftRadius = newVal
          this.pageTurnBorderTopRightRadius = newVal
          this.pageTurnBorderBottomLeftRadius = newVal
          this.pageTurnBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "pageTurnBorderRadius", false)
      }
    },
    pageTurnBorderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pageTurnBorderTopLeftRadius", "pageTurnBorderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderTopLeftRadius", false)
      }
    },
    pageTurnBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "pageTurnBorderTopRightRadius",
          "pageTurnBorderTopRightRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderTopRightRadius", false)
      }
    },
    pageTurnBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "pageTurnBorderBottomLeftRadius",
          "pageTurnBorderBottomLeftRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderBottomLeftRadius", false)
      }
    },
    pageTurnBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "pageTurnBorderBottomRightRadius",
          "pageTurnBorderBottomRightRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderBottomRightRadius", false)
      }
    },
    pageTurnBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "pageTurnBorderIsThemeColor",
          "pageTurnBorderIsThemeColor",
          false
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderIsThemeColor", false)
      }
    },
    pageTurnBorderWidth: {
      get() {
        return this.options.hasOwnProperty("pageTurnBorderWidth") ? this.options.pageTurnBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderWidth", false)
      }
    },
    pageTurnBorderStyle: {
      get() {
        return this.options.hasOwnProperty("pageTurnBorderStyle") ? this.options.pageTurnBorderStyle : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderStyle", false)
      }
    },
    pageTurnBorderColor: {
      get() {
        return this.options.hasOwnProperty("pageTurnBorderColor") ? this.options.pageTurnBorderColor : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pageTurnBorderColor", false)
      }
    },

    hoverPageTurnIconColor: {
      get() {
        return this.options.hoverPageTurnIconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnIconColor", false)
      }
    },
    hoverPageTurnFontColor: {
      get() {
        return this.options.hoverPageTurnFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnFontColor", false)
      }
    },
    hoverPageTurnBgColor: {
      get() {
        return this.options.hoverPageTurnBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBgColor", false)
      }
    },
    hoverPageTurnBgIsThemeColor: {
      get() {
        return this.options.hoverPageTurnBgIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBgIsThemeColor", false)
      }
    },
    hoverPageTurnIconIsThemeColor: {
      get() {
        return this.options.hoverPageTurnIconIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnIconIsThemeColor", false)
      }
    },

    hoverPageTurnPadding: {
      get() {
        return this.options.hoverPageTurnPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnPadding", false)
      }
    },
    hoverPageTurnPaddingTop: {
      get() {
        return this.options.hoverPageTurnPaddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnPaddingTop", false)
      }
    },
    hoverPageTurnPaddingRight: {
      get() {
        return this.options.hoverPageTurnPaddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnPaddingRight", false)
      }
    },
    hoverPageTurnPaddingLeft: {
      get() {
        return this.options.hoverPageTurnPaddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnPaddingLeft", false)
      }
    },
    hoverPageTurnPaddingBottom: {
      get() {
        return this.options.hoverPageTurnPaddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnPaddingBottom", false)
      }
    },
    hoverPageTurnPaddingTypeFlag: {
      get() {
        return this.options.hoverPageTurnPaddingTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnPaddingTypeFlag", false)
      }
    },

    hoverPageTurnBorderTypeFlag: {
      get() {
        return this.options.hoverPageTurnBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderTypeFlag", false)
      }
    },
    hoverPageTurnBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverPageTurnBorderRadius",
          "hoverPageTurnBorderRadius",
          this.hoverPageTurnBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.hoverPageTurnBorderTypeFlag === 2) {
          this.hoverPageTurnBorderTopLeftRadius = newVal
          this.hoverPageTurnBorderTopRightRadius = newVal
          this.hoverPageTurnBorderBottomLeftRadius = newVal
          this.hoverPageTurnBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "hoverBorderRadius", false)
      }
    },
    hoverPageTurnBorderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverPageTurnBorderTopLeftRadius",
          "hoverPageTurnBorderTopLeftRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderTopLeftRadius", false)
      }
    },
    hoverPageTurnBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverPageTurnBorderTopRightRadius",
          "hoverPageTurnBorderTopRightRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderTopRightRadius", false)
      }
    },
    hoverPageTurnBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverPageTurnBorderBottomLeftRadius",
          "hoverPageTurnBorderBottomLeftRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderBottomLeftRadius", false)
      }
    },
    hoverPageTurnBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverPageTurnBorderBottomRightRadius",
          "hoverPageTurnBorderBottomRightRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderBottomRightRadius", false)
      }
    },

    hoverPageTurnBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverPageTurnBorderIsThemeColor",
          "hoverPageTurnBorderIsThemeColor",
          false
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderIsThemeColor", false)
      }
    },
    hoverPageTurnBorderWidth: {
      get() {
        return this.options.hasOwnProperty("hoverPageTurnBorderWidth") ? this.options.hoverPageTurnBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderWidth", false)
      }
    },
    hoverPageTurnBorderStyle: {
      get() {
        return this.options.hasOwnProperty("hoverPageTurnBorderStyle") ? this.options.hoverPageTurnBorderStyle : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderStyle", false)
      }
    },
    hoverPageTurnBorderColor: {
      get() {
        return this.options.hasOwnProperty("hoverPageTurnBorderColor") ? this.options.hoverPageTurnBorderColor : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPageTurnBorderColor", false)
      }
    },

    activeFontSize: {
      get() {
        return this.options.activeFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontSize", false)
      }
    },
    activeFontFamily: {
      get() {
        return this.options.activeFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontFamily", false)
      }
    },
    activeFontWeight: {
      get() {
        return this.options.activeFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeFontWeight", false)
      }
    },
    activeColor: {
      get() {
        return this.options.activeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeColor", false)
      }
    },

    activePadding: {
      get() {
        return this.options.activePadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePadding", false)
      }
    },
    activePaddingTop: {
      get() {
        return this.options.activePaddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingTop", false)
      }
    },
    activePaddingRight: {
      get() {
        return this.options.activePaddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingRight", false)
      }
    },
    activePaddingLeft: {
      get() {
        return this.options.activePaddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingLeft", false)
      }
    },
    activePaddingBottom: {
      get() {
        return this.options.activePaddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingBottom", false)
      }
    },
    activePaddingTypeFlag: {
      get() {
        return this.options.activePaddingTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activePaddingTypeFlag", false)
      }
    },

    activeBorderTypeFlag: {
      get() {
        return this.options.activeBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTypeFlag", false)
      }
    },
    activeBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activeBorderRadius",
          "activeBorderRadius",
          this.activeBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.activeBorderTypeFlag === 2) {
          this.activeBorderTopLeftRadius = newVal
          this.activeBorderTopRightRadius = newVal
          this.activeBorderBottomLeftRadius = newVal
          this.activeBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "activeBorderRadius", false)
      }
    },
    activeBorderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeBorderTopLeftRadius", "activeBorderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopLeftRadius", false)
      }
    },
    activeBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeBorderTopRightRadius", "activeBorderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderTopRightRadius", false)
      }
    },
    activeBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activeBorderBottomLeftRadius",
          "activeBorderBottomLeftRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomLeftRadius", false)
      }
    },
    activeBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "activeBorderBottomRightRadius",
          "activeBorderBottomRightRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderBottomRightRadius", false)
      }
    },
    activeBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "activeBorderIsThemeColor", "activeBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderIsThemeColor", false)
      }
    },
    activeBorderWidth: {
      get() {
        return this.options.hasOwnProperty("activeBorderWidth") ? this.options.activeBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderWidth", false)
      }
    },
    activeBorderStyle: {
      get() {
        return this.options.hasOwnProperty("activeBorderStyle") ? this.options.activeBorderStyle : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderStyle", false)
      }
    },
    activeBorderColor: {
      get() {
        return this.options.hasOwnProperty("activeBorderColor") ? this.options.activeBorderColor : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBorderColor", false)
      }
    },
    activeBgColor: {
      get() {
        return this.options.activeBgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColor", false)
      }
    },
    activeBgColorIsThemeColor: {
      get() {
        return this.options.activeBgColorIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBgColorIsThemeColor", false)
      }
    },
    activeBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("activeBoxShadowColor")
          ? this.options.activeBoxShadowColor
          : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowColor", false)
      }
    },
    activeBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("activeBoxShadowH") ? this.options.activeBoxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowH", false)
      }
    },
    activeBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("activeBoxShadowV") ? this.options.activeBoxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowV", false)
      }
    },
    activeBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("activeBoxShadowBlur") ? this.options.activeBoxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowBlur", false)
      }
    },
    activeBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("activeBoxShadowSpread") ? this.options.activeBoxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "activeBoxShadowSpread", false)
      }
    },

    allBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("allBoxShadowColor")
          ? this.options.allBoxShadowColor
          : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBoxShadowColor", false)
      }
    },
    allBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("allBoxShadowH") ? this.options.allBoxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBoxShadowH", false)
      }
    },
    allBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("allBoxShadowV") ? this.options.allBoxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBoxShadowV", false)
      }
    },
    allBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("allBoxShadowBlur") ? this.options.allBoxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBoxShadowBlur", false)
      }
    },
    allBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("allBoxShadowSpread") ? this.options.allBoxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBoxShadowSpread", false)
      }
    },
    allBorderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("allBorderTypeFlag")) {
          if (
            ((this.allBorderTopLeftRadius === this.allBorderTopRightRadius) === this.allBorderBottomLeftRadius) ===
            this.allBorderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.allBorderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTypeFlag", false)
      }
    },
    allBorderRadius: {
      get() {
        // return this.options.borderRadius || 0
        return this.checkAndSetPrimaryVal(
          this.options,
          "allBorderRadius",
          "allBorderRadius",
          this.allBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.allBorderTypeFlag === 2) {
          this.allBorderTopLeftRadius = newVal
          this.allBorderTopRightRadius = newVal
          this.allBorderBottomLeftRadius = newVal
          this.allBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "borderRadius", false)
      }
    },
    allBorderTopLeftRadius: {
      get() {
        // return this.options.allBorderTopLeftRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderTopLeftRadius", "allBorderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTopLeftRadius", false)
      }
    },
    allBorderTopRightRadius: {
      get() {
        // return this.options.allBorderTopRightRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderTopRightRadius", "allBorderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderTopRightRadius", false)
      }
    },
    allBorderBottomLeftRadius: {
      get() {
        // return this.options.allBorderBottomLeftRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderBottomLeftRadius", "allBorderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderBottomLeftRadius", false)
      }
    },
    allBorderBottomRightRadius: {
      get() {
        // return this.options.allBorderBottomRightRadius || 0
        return this.checkAndSetPrimaryVal(this.options, "allBorderBottomRightRadius", "allBorderBottomRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderBottomRightRadius", false)
      }
    },
    allBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "allBorderIsThemeColor", "allBorderIsThemeColor", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderIsThemeColor", false)
      }
    },
    allBorderWidth: {
      get() {
        return this.options.hasOwnProperty("allBorderWidth") ? this.options.allBorderWidth : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderWidth", false)
      }
    },
    allBorderStyle: {
      get() {
        return this.options.hasOwnProperty("allBorderStyle") ? this.options.allBorderStyle : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderStyle", false)
      }
    },
    allBorderColor: {
      get() {
        return this.options.hasOwnProperty("allBorderColor") ? this.options.allBorderColor : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allBorderColor", false)
      }
    },
    allPadding: {
      get() {
        return this.options.allPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allPadding", false)
      }
    },
    allPaddingTop: {
      get() {
        return this.options.allPaddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allPaddingTop", false)
      }
    },
    allPaddingRight: {
      get() {
        return this.options.allPaddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allPaddingRight", false)
      }
    },
    allPaddingLeft: {
      get() {
        return this.options.allPaddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allPaddingLeft", false)
      }
    },
    allPaddingBottom: {
      get() {
        return this.options.allPaddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allPaddingBottom", false)
      }
    },
    allPaddingTypeFlag: {
      get() {
        return this.options.allPaddingTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "allPaddingTypeFlag", false)
      }
    },

    hoverColor: {
      get() {
        return this.options.hoverColor || this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverColor", false)
      }
    },
    hoverFontWeight: {
      get() {
        return this.options.hoverFontWeight || this.options.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontWeight", false)
      }
    },
    hoverFontFamily: {
      get() {
        return this.options.hoverFontFamily || this.options.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontFamily", false)
      }
    },
    hoverFontSize: {
      get() {
        return this.options.hoverFontSize || parseInt(this.options.fontSize)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverFontSize", false)
      }
    },

    hoverBgColor: {
      get() {
        return this.options.hoverBgColor || this.options.bgColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColor", false)
      }
    },
    hoverBgColorIsThemeColor: {
      get() {
        return this.options.hasOwnProperty("hoverBgColorIsThemeColor") ? this.options.hoverBgColorIsThemeColor : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBgColorIsThemeColor", false)
      }
    },

    hoverBorderColor: {
      get() {
        return this.options.hoverBorderColor || this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderColor", false)
      }
    },
    hoverBorderWidth: {
      get() {
        return this.options.hasOwnProperty("hoverBorderWidth")
          ? this.options.hoverBorderWidth
          : this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderWidth", false)
      }
    },
    hoverBorderStyle: {
      get() {
        return this.options.hasOwnProperty("hoverBorderStyle")
          ? this.options.hoverBorderStyle
          : this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderStyle", false)
      }
    },
    hoverBorderIsThemeColor: {
      get() {
        return this.options.hoverBorderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderIsThemeColor", false)
      }
    },

    hoverPadding: {
      get() {
        return this.options.hoverPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPadding", false)
      }
    },
    hoverPaddingTop: {
      get() {
        return this.options.hoverPaddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingTop", false)
      }
    },
    hoverPaddingRight: {
      get() {
        return this.options.hoverPaddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingRight", false)
      }
    },
    hoverPaddingLeft: {
      get() {
        return this.options.hoverPaddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingLeft", false)
      }
    },
    hoverPaddingBottom: {
      get() {
        return this.options.hoverPaddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingBottom", false)
      }
    },
    hoverPaddingTypeFlag: {
      get() {
        return this.options.hoverPaddingTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverPaddingTypeFlag", false)
      }
    },

    hoverBorderTypeFlag: {
      get() {
        return this.options.hoverBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTypeFlag", false)
      }
    },
    hoverBorderRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverBorderRadius",
          "hoverBorderRadius",
          this.hoverBorderTopLeftRadius
        )
      },
      set(newVal) {
        if (this.hoverBorderTypeFlag === 2) {
          this.hoverBorderTopLeftRadius = newVal
          this.hoverBorderTopRightRadius = newVal
          this.hoverBorderBottomLeftRadius = newVal
          this.hoverBorderBottomRightRadius = newVal
        }
        this.$changeOptionsEV(newVal, "hoverBorderRadius", false)
      }
    },
    hoverBorderTopLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverBorderTopLeftRadius", "hoverBorderTopLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopLeftRadius", false)
      }
    },
    hoverBorderTopRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverBorderTopRightRadius", "hoverBorderTopRightRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderTopRightRadius", false)
      }
    },
    hoverBorderBottomLeftRadius: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "hoverBorderBottomLeftRadius", "hoverBorderBottomLeftRadius", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomLeftRadius", false)
      }
    },
    hoverBorderBottomRightRadius: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.options,
          "hoverBorderBottomRightRadius",
          "hoverBorderBottomRightRadius",
          0
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBorderBottomRightRadius", false)
      }
    },

    hoverBoxShadowColor: {
      get() {
        return this.options.hasOwnProperty("hoverBoxShadowColor")
          ? this.options.hoverBoxShadowColor
          : ["rgba(255,255,255,1)"]
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowColor", false)
      }
    },
    hoverBoxShadowH: {
      get() {
        return this.options.hasOwnProperty("hoverBoxShadowH") ? this.options.hoverBoxShadowH : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowH", false)
      }
    },
    hoverBoxShadowV: {
      get() {
        return this.options.hasOwnProperty("hoverBoxShadowV") ? this.options.hoverBoxShadowV : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowV", false)
      }
    },
    hoverBoxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("hoverBoxShadowBlur") ? this.options.hoverBoxShadowBlur : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowBlur", false)
      }
    },
    hoverBoxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("hoverBoxShadowSpread") ? this.options.hoverBoxShadowSpread : 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hoverBoxShadowSpread", false)
      }
    },

    hideOnSinglePage: {
      get() {
        return this.options.hideOnSinglePage
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "hideOnSinglePage", false)
      }
    },
    showJumper: {
      get() {
        return this.options.showJumper
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showJumper", false)
      }
    },
    showTotal: {
      get() {
        return this.options.showTotal
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showTotal", false)
      }
    },
    maxPageBtnNum: {
      get() {
        return this.options.maxPageBtnNum
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "maxPageBtnNum", false)
      }
    },

    contentHasLimit: {
      get() {
        return this.options.contentHasLimit
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "contentHasLimit", false)
      }
    },
    textLimitLines: {
      get() {
        return this.options.textLimitLines
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textLimitLines", false)
      }
    },
    // 边距
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.options.padding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.paddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.paddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.paddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.paddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    otherFontFamily: {
      get() {
        return this.options.otherFontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "otherFontFamily", false)
      }
    },
    otherFontSize: {
      get() {
        return this.options.otherFontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "otherFontSize", false)
      }
    },
    otherFontWeight: {
      get() {
        return this.options.otherFontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "otherFontWeight", false)
      }
    },
    otherFontColor: {
      get() {
        return this.options.otherFontColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "otherFontColor", false)
      }
    },
    lineHeightType: {
      get() {
        return this.options.lineHeightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    letterSpacingType: {
      get() {
        return this.options.letterSpacingType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "letterSpacingType", false)
      }
    }
  },
  methods: {
    changeAlignType(value) {
      this.alignType = value
    },
    changeBorderRadiusType(value) {
      this.borderTypeFlag = value
    },
    changeStyle(flag, temp, ishover) {
      switch (flag) {
        case 0:
          let weightPropName = ishover ? "hoverFontWeight" : "fontWeight"
          if (temp) {
            this.fontStyleList[flag].isActive = false
            this[weightPropName] = 400
          } else {
            this.fontStyleList[flag].isActive = true
            this[weightPropName] = 500
          }
          break
        case 1:
          let stylePropName = ishover ? "hoverFontStyle" : "fontStyle"
          if (temp) {
            this.fontStyleList[flag].isActive = false
            this[stylePropName] = "normal"
          } else {
            this.fontStyleList[flag].isActive = true
            this[stylePropName] = "italic"
          }
          break
        case 2:
          let textPropName = ishover ? "hoverTextDecoration" : "textDecoration"
          if (temp) {
            this.fontStyleList[flag].isActive = false
            this[textPropName] = "none"
          } else {
            this.fontStyleList[flag].isActive = true
            this[textPropName] = "underline"
          }
          break
      }
    },
    changeArrangement(val, hoverFlag) {
      let cutTextAlign = hoverFlag ? hoverFlag + "TextAlign" : "textAlign"
      this[cutTextAlign] = val.value
    },
    changeArrangementOrder(flag, hoverFlag) {
      let curActiveArrangementOrder = hoverFlag ? hoverFlag + "ActiveArrangementOrder" : "activeArrangementOrder"
      let curWritingMode = hoverFlag ? hoverFlag + "WritingMode" : "writingMode"
      if (flag) {
        this[curActiveArrangementOrder].isActive = false
        this.$changeOptionsEV("horizontal-tb", curWritingMode, false)
      } else {
        this[curActiveArrangementOrder].isActive = true
        this.$changeOptionsEV("vertical-lr", curWritingMode, false)
      }
    },
    changeClassLength() {
      if (this.singleTabs) return
      const params = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInLayoutId: this.ids.elementInLayoutId,
        directionIndex: this.ids.directionIndex,
        maxLength: this.maxLength
      }
      this.$store.dispatch(this.request_prefix + "/changeLayoutTabsLength", params)
    },
    resetBorder(val) {
      this.borderRadius = val
      this.borderTopLeftRadius = val
      this.borderTopRightRadius = val
      this.borderBottomRightRadius = val
      this.borderBottomLeftRadius = val
    },
    collapseMouseDownOther($event, val) {
      if (val === "8" && this.allTabs.length === 0) {
        this.getAllTabs()
      }
    },
    // checkboxHandle(flag, hoverFlag) {
    //   switch (flag) {
    //     case 1:
    //       // this.shapeType = "square"
    //       this[hoverFlag + "borderTopLeftRadius"] = 0
    //       this[hoverFlag + "borderTopRightRadius"] = 0
    //       this[hoverFlag + "borderBottomLeftRadius"] = 0
    //       this[hoverFlag + "borderBottomRightRadius"] = 0
    //       break
    //     case 2:
    //       this[hoverFlag + "borderColor"] = "#FFFFFF"
    //       this[hoverFlag + "borderWidth"] = 1
    //       this[hoverFlag + "borderStyle"] = "solid"
    //       this.changeBorderSelection(hoverFlag)
    //       break
    //     case 3:
    //       this[hoverFlag + "boxShadowColor"] = "#FFFFFF"
    //       this[hoverFlag + "boxShadowH"] = 0
    //       this[hoverFlag + "boxShadowV"] = 0
    //       this[hoverFlag + "boxShadowBlur"] = 0
    //       this[hoverFlag + "boxShadowSpread"] = 0
    //       break
    //     case 4:
    //       this[hoverFlag + "rotate"] = "0deg"
    //       break
    //   }
    // },
    // 获取当前tab组件的的所有选项卡
    getAllTabs() {
      let syncTabIndexList = [] // 除去当前选中的tab的所有tab的index集合
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      for (let i = 0; i < rectAttr.options.rows.length; i++) {
        if (i !== rectAttr.options.activeIndex) {
          const obj = {
            index: i,
            isChecked: false
          }
          syncTabIndexList.push(obj)
        }
      }
      this.allTabs = syncTabIndexList
    },
    // 同步当前选中tab对应的col
    syncTab() {
      for (let i = 0; i < this.allTabs.length; i++) {
        if (this.allTabs[i].isChecked) {
          const rectAttr = this.getRectAttribute.call(this, this.ids)
          const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
          const result = {
            ...this.ids,
            content: JSON.parse(JSON.stringify([rectAttr.options.rows[useActiveIndex]]))[0],
            index: this.allTabs[i].index
          }
          this.$store.dispatch(this.request_prefix + "/changeTabMapRowContent", result)
        }
      }
    },
    // 选中所有tab
    checkAllTabsHandle($event) {
      this.allTabsIsCheckedAll = false // 去掉部分选中状态
      this.allTabs.map(item => (item.isChecked = $event))
    },
    // 选中当前tab
    changeTabsCheckedHandle(val, index) {
      let checkedTabs = 0
      this.allTabs[index].isChecked = val
      this.allTabs.map(item => {
        if (item.isChecked) {
          checkedTabs++
        }
      })
      if (checkedTabs === 0) {
        this.allTabsIsCheckedAll = false
        this.getAllTabsIsCheckedAll = false
      } else {
        if (checkedTabs !== this.allTabs.length) {
          this.allTabsIsCheckedAll = true
        } else {
          this.allTabsIsCheckedAll = false
          this.getAllTabsIsCheckedAll = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.w88 {
  width: 88px;
}
.w72 {
  width: 72px;
}
.content-item {
  .font-style input {
    width: 100%;
    height: 28px;
  }
}
.col_li {
  padding-left: 8px;
}
.col_li:hover {
  background: var(--themeColorSelectBg);
}
.syncCol_flex {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.syncCol_btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 8px;
  width: 80px;
  height: 28px;
  background: var(--themeColor);
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
}
.syncCol_content {
  background: var(--inputArrowBgColor);
  border: 1px solid var(--borderColorTen);
  border-radius: 4px;
  padding: 8px 4px;
}
</style>
